import { initializeLogger as y } from "@seamless/logger";
/**
 * @preserve
 * Licenses of bundled dependencies can be found in dependencies-licenses.txt
 */
const d = (l, t, r, i = !1) => {
  const c = new Intl.NumberFormat(t, {
    style: "currency",
    currency: r.currency ?? "EUR",
    currencyDisplay: r.currencyDisplay,
    minimumFractionDigits: r.decimalDigitsCount ?? 0,
    maximumFractionDigits: r.decimalDigitsCount ?? 0,
    useGrouping: r.useGrouping
  }), m = {
    currency: i ? "" : r.currencySymbol,
    group: r.groupSeparator,
    decimal: r.decimalSeparator
  }, u = c.formatToParts(l).map(({ type: e, value: s }) => ({ type: e, value: m[e] ?? s }));
  let p;
  if (r.pattern) {
    const [e, s] = ["currency", "minusSign"].map(
      (o) => {
        var a;
        return (a = u.find((f) => f.type === o)) == null ? void 0 : a.value;
      }
    ), g = u.reduce((o, a) => (["literal", "currency", "minusSign"].includes(a.type) || (o += a.value), o), "").trim();
    p = r.pattern.replace("{-}", s ?? r.signFallback ?? "").replace("{$}", e ?? "").replace("{price}", g);
  } else
    p = u.map((e) => e.value).reduce((e, s) => e + s);
  return `${p}${r.suffix ?? ""}`.trim();
};
class n {
  constructor() {
    this.configs = {}, this.logger = y("PLS.CURRENCY_FORMATING"), this.assetServerSubDomain = {
      dev: "test.",
      int: "int.",
      preprod: "preprod.",
      prod: ""
    };
  }
  static async initialize(t = "prod") {
    return n.instance || (n.instance = new n(), n.instance.configs = await n.instance.fetchConfig(t)), n.instance;
  }
  static formatToMarketSpecificCurrency(t, r, i = !1) {
    if (!this.instance)
      throw new Error("Currency-Formatting, formatter instance accessed before initialization");
    return this.instance.configs[r] || this.instance.logger.warn("Currency-Formatting", `locale ${r} not found.`), d(t, r, this.instance.configs[r] ?? {}, i);
  }
  async fetchConfig(t) {
    try {
      const i = `https://${this.assetServerSubDomain[t]}assets.oneweb.mercedes-benz.com/plugin/pls-product-pricing-config/utilities/special-price-format.json`, c = await fetch(i);
      if (!c.ok)
        this.logger.error("Currency-Formatting", `Formatting configs for ${t} could not be fetched.`);
      else
        return c.json();
    } catch {
      this.logger.error("Currency-Formatting", `Formatting configs for ${t} could not be fetched.`);
    }
    return {};
  }
}
export {
  n as PriceFormatService
};
//# sourceMappingURL=index.es.js.map
